import i18n from 'i18n-js';
import { bool, func, string } from 'prop-types';

import ButtonPlain from '~/components/ButtonPlain';
import { PopupMinimalisticWithTransition } from '~/components/PopupsWithTransition';

import { ReactComponent as Crown } from '~/assets/images/crown.svg';

import styles from './SubscriptionPopup.module.scss';

export default function SubscriptionPopup({
  buttonText,
  header,
  description,
  show,
  onClick,
  onClose,
}) {
  return (
    <PopupMinimalisticWithTransition
      containerClassName={styles.popupContainer}
      className={styles.popup}
      show={show}
      onClose={onClose}
    >
      <Crown />
      <div className={styles.header}>{i18n.t(header)}</div>
      <div className={styles.description}>{i18n.t(description)}</div>
      <ButtonPlain
        className={styles.button}
        onClick={onClick}
      >
        {i18n.t(buttonText)}
      </ButtonPlain>
    </PopupMinimalisticWithTransition>
  );
}

SubscriptionPopup.propTypes = {
  buttonText: string.isRequired,
  header: string.isRequired,
  description: string.isRequired,
  show: bool.isRequired,
  onClick: func.isRequired,
  onClose: func.isRequired,
};
